import { Operator } from '../global'

interface Comparator {
    compare(actual: string | string[], value: string | string[]): boolean
}

export class EqualsComparator implements Comparator {
    public compare(actual: string | string[], value: string): boolean {
        return Array.isArray(actual) ? actual.includes(value) : actual === value
    }
}

export class InComparator implements Comparator {
    public compare(actual: string | string[], value: string[]): boolean {
        return Array.isArray(actual)
            ? actual.some((a) => value.includes(a))
            : value.includes(actual)
    }
}

export class ComparatorFactory {
    public static create(operator: Operator): Comparator {
        if (operator === 'equals') {
            return new EqualsComparator()
        }

        return new InComparator()
    }
}
